import { render, staticRenderFns } from "./AddIasProjectsDialog.vue?vue&type=template&id=13af17ba&"
import script from "./AddIasProjectsDialog.vue?vue&type=script&lang=js&"
export * from "./AddIasProjectsDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddIasProjectsDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports